export const REQUEST_TYPES = ['PTO', 'NTD', 'FIELD'];
export const TIME_OFF_KINDS = ['JURY_DUTY', 'BEREAVEMENT', 'UNPAID', 'VOLUNTEER', 'VOTE'];
export const VOTE_WINDOWS = ['START_OF_DAY', 'END_OF_DAY'];
export const BEREAVEMENT_RELATIONSHIPS = ['IMMEDIATE', 'EXTENDED', 'OTHER'];
/** Statuses that hold a calendar slot and count against a balance. */
export function isLive(r) {
    return r.status === 'PENDING' || r.status === 'APPROVED';
}
//# sourceMappingURL=types.js.map